import axios, {AxiosResponse} from 'axios'

// Get all roles
const getRoles = async ({params}) => {
  const response = await axios.get('/api/role/list', params)
  return response.data
}

// edit role
const EditRole = async (roleId: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`/api/role/edit/${roleId}`)
  return response.data
}

// Get permissions
const getPermissions = async () => {
  const response = await axios.get(`/api/role/get-permissions/`)
  return response.data
}

// Create role
const createRole = async ({data}) => {
  await axios.post('/api/role/store', data)
}

// Get all roles
const getAllRole = async () => {
  const response = await axios.get(`api/role/get-roles/`)
  return response.data
}

// Delete role
const deleteRole = async (role_id: string) => {
  await axios.post(`/api/role/destroy/${role_id}`)
}

const roleService = {
  getRoles,
  EditRole,
  getPermissions,
  createRole,
  getAllRole,
  deleteRole,
}

export default roleService
